/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCpu2 = createReactComponent("cpu-2", "IconCpu2", [
  [
    "path",
    {
      d: "M5 5m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M8 10v-2h2m6 6v2h-2m-4 0h-2v-2m8 -4v-2h-2", key: "svg-1" }],
  ["path", { d: "M3 10h2", key: "svg-2" }],
  ["path", { d: "M3 14h2", key: "svg-3" }],
  ["path", { d: "M10 3v2", key: "svg-4" }],
  ["path", { d: "M14 3v2", key: "svg-5" }],
  ["path", { d: "M21 10h-2", key: "svg-6" }],
  ["path", { d: "M21 14h-2", key: "svg-7" }],
  ["path", { d: "M14 21v-2", key: "svg-8" }],
  ["path", { d: "M10 21v-2", key: "svg-9" }]
]);

export { IconCpu2 as default };
//# sourceMappingURL=IconCpu2.js.map
